<template>
  <div>
  
  <!-- swap button -->
  <i class="icon-icon-reverse" @click="swapHandler">
    <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span>
  </i>

  </div>
</template>

<script>

export default {
  name: 'swap-orig-dest',  
  computed: {
    inputOrig: {
      get: function() {
        return this.$store.getters['tripPlanner/inputs']['origin'];
      },
      set: function( obj ) {
        this.$store.commit('tripPlanner/SET_INPUT_ORIGIN_NAME', obj.name );
        this.$store.commit('tripPlanner/SET_INPUT_ORIGIN_LOCATION', obj );
      }
    },      
    inputDest: {
      get: function() {
        return this.$store.getters['tripPlanner/inputs']['destination'];
      },
      set: function( obj ) {
        this.$store.commit('tripPlanner/SET_INPUT_DESTINATION_NAME', obj.name );
        this.$store.commit('tripPlanner/SET_INPUT_DESTINATION_LOCATION', obj );
      }
    },     
  },
  methods: {
    swapHandler (e) {
      let orig = Object.assign({}, this.inputOrig)
      let dest = Object.assign({}, this.inputDest)
      this.inputOrig = dest
      this.inputDest = orig
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.icon-icon-reverse {
  font-size:33px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SwapOrigDest.vue